'use client';

import type { ApiError } from '@lib/api/api-response';
import type { UseQueryResult } from '@lib/query/client';

import type { User } from '../types/user';
import { selectUser, useAuthMe } from './use-auth-me';

interface UseCurrentUserRecordOptions {
  /**
   * Optional gate. The underlying query is already gated by Clerk's
   * `userId`, so this is purely additive — pass `false` to keep the
   * query disabled even after Clerk hydrates.
   */
  enabled?: boolean;
}

/**
 * Selects the authenticated user's row from the shared `/api/auth/me`
 * cache. Lazy-creates the row on first access via the server-side
 * getOrCreateCurrentUser.
 */
export function useCurrentUserRecord(
  opts: UseCurrentUserRecordOptions = {}
): UseQueryResult<User, ApiError> {
  return useAuthMe(selectUser, opts.enabled);
}
